// import Vue from "vue";
// import VueRouter from "vue-router";
import "babel-polyfill";
// Vue.use(VueRouter);
import vip from "./modules/vip.js"; // 会员
import activity from "./modules/activity.js"; // 活动
import user from "./modules/user.js"; // 用户
import beforeOptimize from "./modules/beforeOptimize"; // 在路由分模块之前的所有路由
import couponModule from "./modules/coupon"; // 优惠券
import changedate from "./modules/changedate"; // 改期
import seatModule from "./modules/seat.js"; // 值机和选座的融合
import inforuleModule from "./modules/inforule"; // 静态页面
import question from "./modules/question.js"; // 问卷调查
import thirdParty from "./modules/thirdParty"; // 第三方对接过渡页面
import member from "./modules/member"; // 会员
import dream from "./modules/dream"; // 亚运梦想
import airbus from "./modules/airbus"; // 云商城
import rest from "./modules/rest"; // 休息室
import news from "./modules/news.js"; // 新闻
import babytk from "./modules/babytk.js"; // 婴儿/儿童票
import special from "./modules/special"; // 特殊旅客
import upgradeClass from "./modules/upgradeClass"; // 升舱
import travel from "./modules/travel"; // 旅行助手
import travelCard from "./modules/travelCard"; // 旅行卡
import mall from "./modules/mall"; // 旅行助手
import sale from "./modules/sale"; // 特卖
import upgrades from "./modules/upgrades"; // 值机柜台升舱
import wrongFlightCertify from "./modules/wrongFlightCertify"; //不正常航班证明
import luggage from './modules/luggage'; // 行李服务
import invoice from './modules/invoice'; // 电子发票
import apply from './modules/apply'; // 疫情退改申请
import wxmp from './modules/wxmp'; // 微信小程序
import plus from './modules/plus'; // 微信小程序
export default new VueRouter({
  routes: [
    // 核心：默认路由跳转配置
    {
      path: '/', // 访问根域名（如 http://yourdomain.com/）时匹配
      redirect: '/newsList' // 重定向到 /newsList 路径
    },
    ...vip,
    ...activity,
    ...user,
    ...beforeOptimize,
    ...couponModule,
    ...changedate,
    ...seatModule,
    ...inforuleModule,
    ...thirdParty,
    ...question,
    ...member,
    ...dream,
    ...airbus,
    ...rest,
    ...news,
    ...babytk,
    ...special,
    ...upgradeClass,
    ...travel,
    ...travelCard,
    ...mall,
    ...sale,
    ...upgrades,
    ...wrongFlightCertify,
    ...luggage,
    ...invoice,
    ...apply,
    ...wxmp,
    ...plus,
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return {
        x: 0,
        y: 0
      };
    }
  }
});
// 解决报错vue-router.esm.js?fe87:2065 Uncaught (in promise) NavigationDuplicated: Avoi
// const originalPush = VueRouter.prototype.push;
// // push
// VueRouter.prototype.push = function push(location, onResolve, onReject) {
//   if (onResolve || onReject)
//     return originalPush.call(this, location, onResolve, onReject);
//   return originalPush.call(this, location).catch(err => err);
// };



// WEBPACK FOOTER //
// ./src/router/index.js